import type { SearchFilterSetItem } from "~/client/components/search/hooks/useSavedSearchFilterSets";
import { SavedSearchFilterSet } from "~/client/components/search/IncrementalSearchResult/SavedSearchFilterSet";
import { buildSearchPathWithParamsBySearchFilterSet } from "~/client/components/search/SearchHistory/buildSearchPathWithParams";
import type { ListItemSelection } from "~/client/hooks/useSelectListItemByKey";
import type { ConnectionWithTotalCount } from "~/client/utils/relay";

interface Props {
  listIndex: number;
  items: ConnectionWithTotalCount<SearchFilterSetItem>;
  query: string;
  listItemSelection: ListItemSelection;
  onDelete: (id: string) => void;
}
export const SavedSearchFilterSetList: React.FC<Props> = ({ listIndex, items, query, listItemSelection, onDelete }) => {
  const selected = items.edges.find((_, itemIndex) => listItemSelection.isItemSelected({ listIndex, itemIndex }));

  if (selected && listItemSelection.isSubmitting) {
    location.assign(buildSearchPathWithParamsBySearchFilterSet(query, selected.node));
  }

  return (
    <ul>
      {items.edges.map((e) => (
        <SavedSearchFilterSet
          key={e.node.id}
          query={query}
          item={e.node}
          isSelected={e.node.id === selected?.node.id}
          onDelete={onDelete}
        />
      ))}
    </ul>
  );
};
